import React from 'react';
import { observer } from 'mobx-react';

import { constants } from '../../config';
import { SessionStore } from '../../stores/SessionStore';
import { AppRedirect, routeNaming } from '../../routes';
import { ScreenStore } from '../../stores/ScreenStore';

const MyAccount = observer(() => {
  if (!SessionStore.loggedIn) {
    return (
      <AppRedirect routeName={routeNaming.HOME} />
    );
  }
  const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;
  if (!mobileVersion) {
    return (
      <AppRedirect routeName={routeNaming.MY_DATA} />
    );
  }
  return (
    <AppRedirect routeName={routeNaming.MY_ACCOUNT_MENU_MOBILE} />
  );
});

export { MyAccount };



// WEBPACK FOOTER //
// ./src/pages/my-account/MyAccount.jsx